module.exports = " <div class=\"card-page-container mdl-shadow--2dp\"> <parameters-form></parameters-form> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/admin/pages/Parameters.vue
// module id = 283
// module chunks = 0